import {
  GetTopicDataFunc,
  SocketInitialDataArgs,
  TopicReducerHandler,
} from "@shared/services/socket/types";
import { SocketTopics } from "@shared/types";

export class InitialDataHandler<
  Topic extends SocketTopics.AGG_TRADES | SocketTopics.AGG_BOTS
> implements TopicReducerHandler<Topic>
{
  private state = {
    counter: 0,
    fetch_initial_data: false,
    as_dict: false,
  };

  add(args: SocketInitialDataArgs) {
    ++this.state.counter;
    this.state.fetch_initial_data = args.fetch_initial_data;
    if (args.as_dict) this.state.as_dict = args.as_dict;

    return this.state.counter === 1;
  }

  remove(): [boolean, boolean] {
    if (this.state.counter > 0) --this.state.counter;
    return [false, this.state.counter === 0];
  }

  getState = () => {
    return {
      fetch_initial_data: this.state.fetch_initial_data,
      as_dict: this.state.as_dict,
      return_fetch_initial_data_flag_on_exception: true,
    };
  };

  getData: GetTopicDataFunc<Topic> = (_, data) => {
    return data;
  };
}
